$(document).ready(function() {
  const $header = $('.header');

  // ページ内スムーススクロール
  $('a[href*="#"]').on('click', function(e) {
    const href = $(this).attr('href');
    if (href.indexOf('#') === -1) return;

    const hash = href.substring(href.indexOf('#'));
    if (hash === '#') return;

    const $target = $(hash);
    if ($target.length === 0) return;

    e.preventDefault();

    const gap = $header.outerHeight() || 0;
    const position = $target.offset().top - gap;

    $('html, body').animate({
      scrollTop: position
    }, 500, 'swing');
  });

  // 別ページから #hash 付きで来た時の処理
  $(window).on('load', function() {
    if (location.hash) {
      const $target = $(location.hash);
      if ($target.length === 0) return;

      // ブラウザのデフォルトスクロールを上書き
      $('html, body').scrollTop(0);

      setTimeout(function() {
        const gap = $header.outerHeight() || 0;
        const position = $target.offset().top - gap;

        $('html, body').animate({
          scrollTop: position
        }, 500, 'swing');
      }, 100); // 描画完了を待つ
    }
  });
});